/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MigrationStatus {
    NONE = 'NONE',
    BIZX_KULCSUSER_CONNECTED = 'BIZX_KULCSUSER_CONNECTED',
    INPROGRESS = 'INPROGRESS',
    DONE = 'DONE',
    DONE_FILESHARE = 'DONE_FILESHARE',
}
